module.exports = __webpack_public_path__ + "img/cloud.aadf72bb.svg";